var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ver_Compras_acumuladas",
    "data-name": "Ver Compras acumuladas",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 60.065,
    viewBox: "0 0 67 60.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1032",
    "data-name": "Caminho 1032",
    d: "M0,2.816A2.809,2.809,0,0,1,2.816,0H8.153a6.57,6.57,0,0,1,5.936,3.754H62.306a4.69,4.69,0,0,1,4.528,5.913l-4.81,17.867a8.46,8.46,0,0,1-8.153,6.253H20.026l.633,3.343a2.826,2.826,0,0,0,2.769,2.288H57.249a2.816,2.816,0,0,1,0,5.631H23.428a8.438,8.438,0,0,1-8.294-6.863L9.08,6.394a.933.933,0,0,0-.927-.763H2.816A2.809,2.809,0,0,1,0,2.816ZM15.016,54.434a5.631,5.631,0,1,1,5.631,5.631A5.631,5.631,0,0,1,15.016,54.434ZM54.434,48.8A5.631,5.631,0,1,1,48.8,54.434,5.631,5.631,0,0,1,54.434,48.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.90e6049b24defa8ae184ad52f49369ba.svg";
export { ForwardRef as ReactComponent };